import React from "react";
/** Components Import */
import Section from "../../Components/Section";
import Card from "../../Components/Card_wrap";
import BasicCombo from "../../Components/Combo_Basic";
import BasicInput from "../../Components/Input_Basic";
import AuthGroupButton from "../../Components/Button_Auth_Group";
import OrderStatusCard from "../../Components/Card_OrderStatus";
import DatePicker from "../../Components/Datepicker_Basic";

function SM10020(props) {
  React.useEffect(() => {
    if (document.title === "주문현황") {
      return;
    } else {
      document.title = "주문현황";

      const element = document.getElementById("topbar");
      element.innerHTML =
        "<h1>" +
        "<span class='bullet'>" +
        "</span>" +
        "<strong class='depth-1'>" +
        "영업관리" +
        "	</strong>" +
        "<span class='divider' >" +
        "</span>" +
        "<strong'>주문현황</strong>" +
        "</h1>";
    }
  }, []);
  return (
    <div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
        }}
      ></div>
      <Card
        wrapStyle={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <BasicCombo
            containerStyle={{ margin: "0px 10px" }}
            value={props.inputs.comboValue}
            onChange={(e) => {
              props.setInputs({
                ...props.inputs,
                comboValue: e,
                searchInput: "",
              });
            }}
            combos={[
              { value: "", name: "" },
              {
                value: "SoNo",
                name:
                  props.lanData.length > 0
                    ? props.lanData.filter(
                        (f) => f.lanId === "Combo_SoNo" && f.lanType === "COMBO"
                      )[0].lanName
                    : "",
              },
              {
                value: "CustNm",
                name:
                  props.lanData.length > 0
                    ? props.lanData.filter(
                        (f) =>
                          f.lanId === "Combo_CustCd" && f.lanType === "COMBO"
                      )[0].lanName
                    : "",
              },
              {
                value: "ItemCd",
                name:
                  props.lanData.length > 0
                    ? props.lanData.filter(
                        (f) =>
                          f.lanId === "Combo_ItemCd" && f.lanType === "COMBO"
                      )[0].lanName
                    : "",
              },
              // {
              //   value: "ContractDt",
              //   name:
              //     props.lanData.length > 0
              //       ? props.lanData.filter(
              //           (f) =>
              //             f.lanId === "Combo_ContractDt" &&
              //             f.lanType === "COMBO"
              //         )[0].lanName
              //       : "",
              // },
            ]}
          />
          <BasicInput
            value={props.inputs.searchInput}
            onChange={(e) => {
              props.setInputs({
                ...props.inputs,
                searchInput: e.target.value,
              });
            }}
            hidden={props.inputs.comboValue === "ContractDt" ? true : false}
            onKeyDown={(e) => {
              if (e.keyCode == 13) {
                props.Init();
              }
            }}
          />
          <DatePicker
            className={"datepicker-custom-input"}
            style={{ width: "120px", marginRight: "5px" }}
            selected={props.startDate}
            onChange={(e) => {
              props.setStartDate(e);
            }}
          />
          ~
          <DatePicker
            className={"datepicker-custom-input"}
            style={{ width: "120px", marginLeft: "5px" }}
            selected={props.endDate}
            onChange={(e) => {
              props.setEndDate(e);
            }}
          />
        </div>

        <AuthGroupButton
          pageName="SM10020"
          target="G01"
          refreshNone="none"
          refreshFunc={() => {
            props.Init();
          }}
          addFunc={() =>
            // gridRef.current.api.setRowData([{}, ...props.rowData])
            props.setModalToggle(true)
          }
          selectFunc={() => {
            props.Init();
          }}
          saveFunc={() => props.SaveConfirm()}
          deleteFunc={() => props.DeleteConfirm()}
        />
      </Card>
      <Section />
      <Section />
      <Card style={{ height: "650px", overflow: "scroll" }}>
        <OrderStatusCard orderList={props.orderList} />
      </Card>
    </div>
  );
}

export default SM10020;
